import { processBOMActions } from "./ProcessBOMReducer";
import { useProcessAPI  } from '../../../api/process/useProcessAPI';

export const useProcessBOM = () => {
    const api = useProcessAPI();
  
    const request = {
        get: (params) => {
          return async (dispatch) => {
            try {
              const response = await api.processBOM.get(params);
              dispatch(processBOMActions.funGetProcessBOM(response));
            } catch (error) {
              console.error('Error fetching data:', error);
            }
          }
        },
        post: async (data) => {
          return await api.processBOM.post(data);
        },
        put: async (data) => {
          return await api.processBOM.put(data);
        },
        delete: async (params) => {
          return await api.processBOM.delete(params);
        }
    };
    return { request };
  };